var IconBadgeIcon;
(function (IconBadgeIcon) {
    IconBadgeIcon["BaseMale"] = "BaseMale";
    IconBadgeIcon["BaseFemale"] = "BaseFemale";
    IconBadgeIcon["Unisex"] = "Unisex";
    IconBadgeIcon["BodyShape"] = "BodyShape";
    IconBadgeIcon["Earring"] = "Earring";
    IconBadgeIcon["Eyebrows"] = "Eyebrows";
    IconBadgeIcon["Eyes"] = "Eyes";
    IconBadgeIcon["Eyewear"] = "Eyewear";
    IconBadgeIcon["FacialHair"] = "FacialHair";
    IconBadgeIcon["Feet"] = "Feet";
    IconBadgeIcon["Hair"] = "Hair";
    IconBadgeIcon["Hat"] = "Hat";
    IconBadgeIcon["Helmet"] = "Helmet";
    IconBadgeIcon["LowerBody"] = "LowerBody";
    IconBadgeIcon["Mask"] = "Mask";
    IconBadgeIcon["Mouth"] = "Mouth";
    IconBadgeIcon["Tiara"] = "Tiara";
    IconBadgeIcon["TopHead"] = "TopHead";
    IconBadgeIcon["UpperBody"] = "UpperBody";
    IconBadgeIcon["Skin"] = "Skin";
    IconBadgeIcon["HandsWear"] = "HandsWear";
    IconBadgeIcon["PlayOnce"] = "PlayOnce";
    IconBadgeIcon["PlayLoop"] = "PlayLoop";
    IconBadgeIcon["SmartWearable"] = "SmartWearable";
    IconBadgeIcon["Sound"] = "Sound";
    IconBadgeIcon["Props"] = "Props";
    IconBadgeIcon["Sparkles"] = "Sparkles";
    IconBadgeIcon["Places"] = "Places";
    IconBadgeIcon["Utility"] = "Utility";
})(IconBadgeIcon || (IconBadgeIcon = {}));
export { IconBadgeIcon };
//# sourceMappingURL=IconBadge.types.js.map